<template>
  <div :class="[
    'form-check btn btn-block btn-option p-0',
    {
      'btn-option-selected': !disabled && selected,
      'btn-option-default': !disabled && !selected,
      'btn-option-disabled': disabled,
    }
  ]"
  >
    <input class="form-check-input d-none"
           :id="computedId"
           type="radio"
           :value="optionValue"
           :disabled="disabled"
           v-on:click="$emit('change', $event.target.value)">
    <label :class="[
        'form-check-label d-flex justify-content-between align-items-center px-3',
      ]"
           :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
           :for="computedId">
      <slot></slot>
    </label>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  optionValue: {
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const computedId = computed(() => props.id || `option-${Math.random().toString(36).substr(2, 9)}`);

</script>

<style scoped>
.form-check-label {
  cursor: pointer;
}

.btn-option label {
  border-radius: 0.3em;
  padding: 0.7em 0.5em;
}

.btn-option-disabled label {
  color: #f1f1f1;
  border: 1px solid #f1f1f1;
}

.btn-option-selected label {
  border: 2px solid #1976d2;
}

.btn-option-default label {
  color: #0a0a0a;
  border: 1px solid #86868b;
}
</style>
